export const PermissionsState = {
    errorCode : 0,
    statusCode : 0,
    permissionsList : [],
    message : '',
    UpdatedList : []
}